export default __webpack_public_path__ + "static/media/sunhotel-logo-white.9673524b.svg";